<template>
  <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content" :ssr="false" attach="body" :max-width="300">
    <button class="modal__close" @click="$emit('closed')" v-text="'X'" />
    <span class="modal__title">Connection error</span>

    <div class="modal__content">
      <p v-text="text" />
    </div>

    <div class="modal__action">
      <button class="btn-orange btn-modal" @click="contactSupport()">Contact support</button>
    </div>
  </vue-final-modal>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";
import { AppConfig } from "@/config";

export default {
  name: "GoogleConnectionError",
  props: {
    showModal: {
      type: Boolean,
      require: true,
    },
    text: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Connection error',
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    showButton: {
      type: Boolean,
      default: true,
    }
  },
  components: { VueFinalModal },
  methods: {
    contactSupport() {
      return window.open(`${AppConfig.siteUrl}/contact.html`, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/colors";
@import "src/assets/style/responsive";

::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba($bgLightGray, 0.2);
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 350px;
  max-height: 90%;
  max-width: 90vw;
  margin: 0 1rem;
  border: 1px solid #e2e8f0;
  padding: 2.5rem 3.5rem;
  border-radius: 5px;
  background: #fff;
  transform: translateY(-50px);
  @include mobile {
    padding: 1.5rem 2.5rem;
  }
}
.modal__title {
  margin: 0 2rem 0.5rem 0;
  font-size: 1.75rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
  padding-top: 1.5rem;
  max-width: 500px;

  @include mobile{
    max-width: unset;
  }
  p {
    word-break: break-word;
    max-width: 100%;
  }
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: 2.5rem;
  right: 2.5rem;
  font-weight: bold;
  background: unset;
  border: unset;
  @include mobile{
    padding: 2.5rem 2rem;
  }
}
.btn-modal {
  background: transparent;
  color: $orange;
  border: 2px solid $orange;
  border-radius: 5px;
  padding: .5em .75em;
  transition: all .2s;

  &:hover {
    background: $orange;
    color: $white;
  }
}
</style>